// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.wgtSettings[data-v-390dc6cb] {\n  min-height: 940px;\n}\n.wgtSettings .cardR[data-v-390dc6cb] {\n  min-height: 920px;\n  width: 100%;\n}\n.wgtSettings .cardR .content-panel1[data-v-390dc6cb] {\n  min-height: 100%;\n}\n.cardR .boxR[data-v-390dc6cb] {\n  height: 100%;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
